<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 375 458"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.7">
      <rect
        x="316"
        y="134.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 316 134.102)"
        class="lighter-fill"
      />
      <rect
        x="292"
        y="134.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 292 134.204)"
        class="darker-fill"
      />
      <rect
        x="292"
        y="401.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 292 401.204)"
        class="darker-fill"
      />
      <rect
        x="292"
        y="416.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 292 416.204)"
        class="lighter-fill"
      />
      <rect
        x="-252"
        y="437.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -252 437.102)"
        class="lighter-fill"
      />
      <rect
        x="-231.908"
        y="414.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -231.908 414.204)"
        class="darker-fill"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

svg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: $quaternary-lighter;
}

.lighter-fill {
  fill: $secondary-lighter;
}

.darker-fill {
  fill: $secondary-darker;
}
</style>